import * as React from 'react';
import {
  Button,
  notification
} from 'antd';
import projectsModal from '../Modals/set/projects';
import removeItem from '../Modals/set/removeItem';
import Table from '../../components/Table'
import Pagination from '../../components/Pagination'
import projectsAPI from '../../API/projects';
import errors from "../../API/error";
import TablePagination from "../../services/tablePagination";
import Settings from "../../layouts/Settings";
import columns from "./columns";

interface IState {
  list: object[],
  pagination: any,
  id: string
  loading: boolean
}

class Projects extends React.Component<any, IState> {
  pagination = new TablePagination();
  state = {
    list: [],
    pagination: {
      total: 0
    },
    loading: true,
    id: ''
  };

  componentDidMount() {
    projectsModal.init({onSubmit: this.handleSubmit});
    removeItem.init({onSubmit: this.handleRemove, name: "Project"});
    this.getProjects();
  };

  componentWillUnmount(): void {
    projectsModal.remove();
    removeItem.del();
  }

  getProjects = async () => {
    try {
      this.setState({loading: true});
      const query: any = this.state.pagination;
      const result = await projectsAPI.get({query: {...query, ...this.pagination.requestParams()}});
      const {list, pagination} = result.data;
      this.pagination.value = pagination;
      this.setState({list, pagination, loading: false})
    } catch (e) {
      errors.handle(e);
      this.setState({list: [], loading: false})
    }
  };

  addPosition = () => projectsModal.open();

  handleSubmit = async ({values, onLoading, onCancel, form, modalProps: mp = {}}: any) => {
  
    try {
      onLoading(true);
      if (mp._id) {
        await projectsAPI.update(values, {params: {id: mp._id}});
      } else {
        await projectsAPI.create(values);
      }
      await this.getProjects();
      onLoading(false);
      onCancel();
    } catch (e) {
      errors.handle(e, form, {priority: 'form'});
      onLoading(false);
    }
  };

  handleEdit = (item: any) => {
    
    this.setState({id: item._id});
    projectsModal.open(item);
  };

  handleRemove = async (params: any) => {
    const {modalProps: {_id: id}, onCancel, onLoading} = params;
    try {
      onLoading(true);
      await projectsAPI.remove(null, {params: {id}});
      await this.getProjects();
      notification.success({message: 'Success'});
      onCancel();
    } catch (e) {
      errors.handle(e);
    } finally {
      onLoading(false);
    }
  };

  changePage = (page: number) => {
    this.pagination.page = page;
    this.getProjects();
  };

  render() {
    const {list, loading} = this.state;
   
    return <Settings location={this.props.location} actionsComponent={
      <Button className="ant-btn-primary" onClick={this.addPosition}>
        Create Project
      </Button>
    }>
        <Table dataSource={list}
               rowKey="_id"
               loading={loading}
               columns={columns({
                 actions: {
                   onEdit: this.handleEdit,
                   onRemove: removeItem.open
                 }
               })}
               pagination={this.pagination.tableConfig} />
      <Pagination {...this.pagination.config} onChange={this.changePage} />
    </Settings>
  }
}

export default Projects;